import * as React from 'react'
function SvgDataBar(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8 28c1.2 0 2 .8 2 2v4c0 1.2-.8 2-2 2s-2-.8-2-2v-4c0-1.2.8-2 2-2zm8-8c1.2 0 2 .8 2 2v12c0 1.2-.8 2-2 2s-2-.8-2-2V22c0-1.2.8-2 2-2zm8-8c1.2 0 2 .8 2 2v20c0 1.2-.8 2-2 2s-2-.8-2-2V14c0-1.2.8-2 2-2zm8-8c1.2 0 2 .8 2 2v28c0 1.2-.8 2-2 2s-2-.8-2-2V6c0-1.2.8-2 2-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDataBar
